// Modèles texte sur un <input>/<textarea> natif : insertion au curseur + sauvegarde de la sélection

// Position du curseur/sélection au moment où le picker s'ouvre (fin du texte si champ inconnu)
export function getCaret(el, value) {
    const length = (value || '').length
    if (!el || typeof el.selectionStart !== 'number') return { start: length, end: length }
    return { start: Math.min(el.selectionStart, length), end: Math.min(el.selectionEnd, length) }
}

// Insère le texte du modèle au curseur sans écraser la sélection éventuelle
export function insertAtCaret(value, text, caret) {
    const current = value || ''
    const pos = caret ? Math.min(caret.end, current.length) : current.length
    const next = current.slice(0, pos) + (text || '') + current.slice(pos)
    return { value: next, caret: pos + (text || '').length }
}

// Texte à enregistrer comme modèle : la sélection si elle existe, sinon tout le texte
export function selectedOrAll(value, caret) {
    const current = value || ''
    if (caret && caret.end > caret.start) {
        const selected = current.slice(caret.start, caret.end)
        if (selected.trim()) return selected
    }
    return current
}

// Replace le curseur juste après le texte inséré
export function restoreCaret(el, pos) {
    if (!el || typeof el.setSelectionRange !== 'function') return
    el.focus()
    el.setSelectionRange(pos, pos)
}
